module.exports = __webpack_public_path__ + "img/banner-1.72011a8b.png";